//Modules
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Component } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AngularFileUploaderModule } from "angular-file-uploader";
import { CreditCardDirectivesModule } from 'angular-cc-library';
//import { NgxStripeModule } from 'ngx-stripe';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { NgxMaskModule } from 'ngx-mask';

//swimlane/ngx-datatable
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

//material controls
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatRadioModule } from '@angular/material/radio';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';

//Components
import { AlertDialogComponent } from './shared/UI/alert-dialog/alert-dialog.component';
import { ConfirmationDialogComponent } from './shared/UI/confirmation-dialog/confirmation-dialog.component';
import { PageNotFoundComponent } from './UI/shared/page-not-found/page-not-found.component';
import { MissingCredentialsComponent } from './UI/shared/missing-credentials/missing-credentials.component';
import { AccessDeniedComponent } from './UI/shared/access-denied/access-denied.component';

import { AppComponent } from './app.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { NavMenuComponent } from './UI/nav-menu/nav-menu.component';
import { safehtmlpipe } from './shared/UI/htmlpipe/safehtmlpipe';

import { RoiDocumentComponent } from './UI/contract-wizard/roi-document/roi-document.component';
import { ThankyouComponent } from './UI/contract-wizard/thankyou/thankyou.component';
import { ContractComponent } from './UI/contract-wizard/contract/contract.component';
import { ContractConfigComponent } from './UI/contract-wizard/contract-config/contract-config.component';
import { ContractRemoteComponent } from './UI/contract-wizard/contractRemote/contractRemote.component';
import { ClientRemoteComponent } from './UI/contract-wizard/client-remote/client-remote.component';
import { DocumentExportComponent } from './UI/document-export/document-export.component';
import { ConnectClientComponent } from './UI/contract-wizard/connect-client/connect-client.component';
import { ContractListComponent } from './UI/contract-wizard/contract-list/contract-list.component';
import { ClientExportToPdfComponent } from './UI/client-export-to-pdf/client-export-to-pdf.component';
import { CustContractComponent } from './UI/cust-contract/cust-contract.component';
import { ContractSignatureListComponent } from './UI/contract-signature-list/contract-signature-list.component';
import { ContractListenerComponent } from './UI/contract-wizard/contract-listener/contract-listener.component';
import { PatentPlusContractListComponent } from './UI/patent-plus-contract-wizard/patent-plus-contract-list/patent-plus-contract-list.component';
import { PatentPlusContractComponent } from './UI/patent-plus-contract-wizard/patent-plus-contract/patent-plus-contract.component';
import { PatentPlusContractRemoteComponent } from './UI/patent-plus-contract-wizard/patent-plus-contract-remote/patent-plus-contract-remote.component';
import { PatentPlusClientRemoteComponent } from './UI/patent-plus-contract-wizard/patent-plus-client-remote/patent-plus-client-remote.component';
import { AllocatedFileNumbersListComponent } from './UI/allocated-file-numbers-list/allocated-file-numbers-list.component';

//Utility Services
import { UtilityService } from './services/shared/utility.service';
import { AppconfigService } from './services/shared/appconfig.service';

//WebAPI (Services)
import { CountryService } from './services/country.service';
import { StateService } from './services/state.service';
import { UserService } from './services/user.service';
import { DocumentService } from './services/document.service';
import { ContactService } from './services/contact.service';
import { InventionService } from './services/invention.service';
import { WizardService } from './services/wizard.service';
import { SMSService } from './services/sms.service';
import { MediaImagesService } from './services/mediaimages.service';
import { ContractSessionService } from './services/contractsession.service';
import { BillingService } from './services/billing.service';
import { OfficeService } from './services/office.service';
import { InfoCollectService } from './services/InfoCollect.service';
import { NavigationService } from './services/navigation.service';
import { ConfigMasterService } from './services/configMaster.service';
import { ProductService } from './services/product.service';
import { EmailService } from './services/email.service';
import { AddendumService } from './services/addendum.service';
import { CheckListService } from './services/checkList.service';
import { ChatService } from './services/shared/chat.service';
import { InventionCheckListService } from './services/inventionCheckList.service';
import { RemoteSMSService } from './services/remoteSMS.service';
import { ContractRemoteService } from './services/contractRemote.service';

//Directives
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { ContratActionLogService } from './services/contratActionLog.service';
import { TransferDataService } from './services/shared/transferData.service';
import { CurrencyConversionService } from './services/shared/currency-conversion.service';
import { htmlTagDirective } from './directives/replace-htmlTag-directive';
import { WhiteSpaceDirective } from './directives/remove-whitespace-directive';
import { CorpContractComponent } from './UI/corp-contract/corp-contract.component';
import { TwoDigitDecimaNumberDirective } from './directives/two-digit-decimanumber-directive';
import { ClientsStateDataService } from './services/clients-state-data.service';
import { DatePipe } from '@angular/common';

let pages: any = [
    AppComponent,
    NavMenuComponent,
    safehtmlpipe,
    AlertDialogComponent,
    ConfirmationDialogComponent,
    PageNotFoundComponent,
    MissingCredentialsComponent,
    AccessDeniedComponent,
    PhoneMaskDirective,
    htmlTagDirective,
    WhiteSpaceDirective,
    RoiDocumentComponent,
    ThankyouComponent,
    ContractListComponent,
    PatentPlusContractListComponent,
    ContractComponent,
    PatentPlusContractComponent,
    ContractConfigComponent,
    ContractRemoteComponent,
    PatentPlusContractRemoteComponent,
    ClientRemoteComponent,
    PatentPlusClientRemoteComponent,
    DocumentExportComponent,
    ConnectClientComponent,
    ClientExportToPdfComponent,
    CustContractComponent,
    CorpContractComponent,
    TwoDigitDecimaNumberDirective,
    ContractSignatureListComponent,
    ContractListenerComponent,
    AllocatedFileNumbersListComponent
];

@NgModule({
    declarations: pages,
    imports: [
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        NgxDatatableModule,
        MatDialogModule,
        MatListModule,
        MatInputModule,
        MatTabsModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        MatChipsModule,
        MatMomentDateModule,
        MatDatepickerModule,
        MatCardModule,
        MatExpansionModule,
        MatStepperModule,
        MatGridListModule,
        MatRadioModule,
        MatSnackBarModule,
        MatSidenavModule,
        MatSortModule,
        MatTooltipModule,
        CdkStepperModule,
        SignaturePadModule,
        AngularFileUploaderModule,
        MatPaginatorModule,
        CurrencyMaskModule,
        CreditCardDirectivesModule,
        NgxMaskModule.forRoot(),
        MatProgressBarModule,
        BsDatepickerModule.forRoot()
        //NgxStripeModule.forRoot("PublishableKey"),
    ],
    exports: [
        MatSortModule
    ],
    entryComponents: [
        AlertDialogComponent,
        ConfirmationDialogComponent
    ],
    providers: [
        AppconfigService,
        UtilityService,
        CountryService,
        StateService,
        UserService,
        DocumentService,
        ContactService,
        InventionService,
        WizardService,
        SMSService,
        MediaImagesService,
        ContractSessionService,
        BillingService,
        OfficeService,
        InfoCollectService,
        NavigationService,
        ConfigMasterService,
        ProductService,
        EmailService,
        ContratActionLogService,
        AddendumService,
        TransferDataService,
        CheckListService,
        ChatService,
        InventionCheckListService,
        RemoteSMSService,
        ContractRemoteService,
        CurrencyConversionService,
        ClientsStateDataService,
        DatePipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
